export default "__VITE_ASSET__6a20dede__"